export default __webpack_public_path__ + "static/media/oldlady_biblem.459b1b77.jpg";